import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const STANDING_OFFER_ACCEPT = gql(`
  mutation standingOfferAccept($organizationId: ID!, $standingOfferId: ID!) {
    standingOfferAccept(organizationId: $organizationId, standingOfferId: $standingOfferId) {
      ... on AppSubscription {
        __typename
        id
        app {
          __typename
          displayName
        }
        inboundOrganization {
          __typename
          slug
        }
      }
      ... on SubscriptionOfferCheckoutSession {
        __typename
        portalURL
      }
      ... on OrganizationMissingPaymentMethod {
        __typename
        organizationID
      }
      ... on SubscriptionOfferInvalidStatus {
        __typename
        id
      }
      ... on SubscriptionOfferNotFound {
        __typename
        id
      }
      ... on SubscriptionAlreadyExists {
        __typename
        id
      }
    }
  }
`);

export function useStandingOfferAccept() {
  return useMutation(STANDING_OFFER_ACCEPT);
}
